<template>
  <section v-bind="sectionProps">
    <v-container v-bind="containerProps">
      <v-row v-bind="contentRowProps">
        <v-col v-bind="contentColumnProps">
          <div
            class="section-title"
            v-bind="titleProps"
            v-inline-editable.html="section.content['title']"
          ></div>

          <div
            class="section-introtext"
            v-bind="introtextProps"
            v-inline-editable.html="section.content['introtext']"
          ></div>

          <div
            v-if="
              parseBoolean(section.layout['content-box']) &&
                section.layout['content-box-wrap'] == 'content'
            "
            v-bind="contentBoxProps"
          ></div>

          <v-row
            class="section-items"
            v-bind="itemRowProps"
            v-if="
              section.content['articles'] &&
                JSON.parse(section.content['articles']).length
            "
          >
            <v-col
              class="section-item"
              v-bind="itemColumnProps"
              v-for="(item, index) in JSON.parse(section.content['articles'])"
              :key="index"
            >
              <div class="item-content" v-bind="itemContentProps">
                <img
                  class="item-image"
                  v-if="item['article-image']"
                  v-bind="itemImageProps(item)"
                />

                <div
                  class="item-title"
                  v-bind="itemTitleProps"
                  v-inline-editable.html="item['article-title']"
                ></div>

                <div
                  class="item-introtext"
                  v-bind="itemIntrotextProps"
                  v-inline-editable.html="item['article-introtext']"
                ></div>

                <div
                  class="mt-6"
                  v-if="item['button-text'] && item['button-link']"
                >
                  <link-button
                    class="item-button"
                    :link="item['button-link']"
                    :text="item['button-text']"
                    v-bind="buttonProps(item)"
                  ></link-button>
                </div>

                <div
                  v-if="
                    parseBoolean(section.layout['content-box']) &&
                      section.layout['content-box-wrap'] == 'item'
                  "
                  v-bind="contentBoxProps"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <parallax-background-image
      v-if="section.design['background-image']"
      :section="section"
      v-bind="backgroundImageProps"
    ></parallax-background-image>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
import LinkButton from '@/components/sections/partials/buttons/LinkButton'
import ParallaxBackgroundImage from '@/components/sections/partials/elements/ParallaxBackgroundImage'

export default {
  name: 'CategoryListingDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    LinkButton,
    ParallaxBackgroundImage
  },
  computed: {
    sectionProps() {
      let additionalStyle = {}

      if (this.parseBoolean(this.section.design['custom-padding'])) {
        additionalStyle.paddingTop = this.section.design['padding-top']
        additionalStyle.paddingBottom = this.section.design['padding-bottom']
      }

      return {
        style: {
          backgroundColor: this.section.design['background-color'],
          ...additionalStyle
        }
      }
    },
    backgroundImageProps() {
      return {
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    containerProps() {
      return {
        'fill-height': true,
        fluid: this.parseBoolean(
          this.section.layout['content-container-fluid']
        ),
        style: {
          position: 'relative',
          zIndex: 1
        }
      }
    },
    contentRowProps() {
      return {
        'no-gutters': true,
        class: [
          `justify-${this.section.layout['content-horizontal-alignment']}`,
          `text-${this.section.layout['content-justify']}`
        ]
      }
    },
    contentColumnProps() {
      let additionalProps = {}

      if (!this.parseBoolean(this.section.layout['content-container-fluid'])) {
        additionalProps = {
          ...this.calculateColumnContainerSize(
            this.section.layout['content-container-size']
          )
        }
      }

      return {
        ...additionalProps,
        style: {
          position: 'relative',
          padding:
            this.parseBoolean(this.section.layout['content-box']) &&
            this.section.layout['content-box-wrap'] == 'content'
              ? this.section.layout['content-box-padding']
              : 0
        }
      }
    },
    titleProps() {
      return {
        is: this.section.design['title-tag'],
        style: {
          color: this.section.design['title-color'],
          fontWeight: this.section.design['title-font-weight'],
          margin: this.section.content['title'] ? '' : '0'
        }
      }
    },
    introtextProps() {
      return {
        style: {
          color: this.section.design['introtext-color']
        }
      }
    },
    itemRowProps() {
      return {
        class: {
          'mt-5':
            this.section.content['title'] || this.section.content['introtext']
        }
      }
    },
    itemColumnProps() {
      return {
        ...this.calculateColumns(this.section.layout['article-columns']),
        class: ['d-flex'],
        'flex-direction': 'column'
      }
    },
    itemContentProps() {
      return {
        style: {
          width: '100%',
          position: 'relative',
          padding:
            this.parseBoolean(this.section.layout['content-box']) &&
            this.section.layout['content-box-wrap'] == 'item'
              ? this.section.layout['content-box-padding']
              : 0
        }
      }
    },
    itemTitleProps() {
      return {
        is: this.section.design['article-title-tag'],
        style: {
          color: this.section.design['article-title-color'],
          fontWeight: this.section.design['article-title-font-weight']
        }
      }
    },
    itemIntrotextProps() {
      return {
        style: {
          color: this.section.design['article-introtext-color']
        }
      }
    },
    contentBoxProps() {
      let additionalClass = []

      if (this.parseBoolean(this.section.layout['content-box-rounded'])) {
        additionalClass.push('rounded')
      }

      return {
        class: [
          `elevation-${this.section.layout['content-box-elevation']}`,
          ...additionalClass
        ],
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundColor: this.section.layout['content-box-color'],
          opacity: this.section.layout['content-box-opacity'],
          border: `${this.section.layout['content-box-border']}px solid ${this.section.layout['content-box-border-color']}`
        }
      }
    },
    articleImageSize() {
      switch (this.section.layout['article-columns']) {
        case '1':
          return 'lg'
        case '2':
          return 'md'
        case '3':
          return 'md'
        case '4':
          return 'sm'
        case '5':
          return 'sm'
        case '6':
          return 'xs'
        default:
          return 'lg'
      }
    }
  },
  methods: {
    itemImageProps(item) {
      return {
        src: this.loadMedia(item['article-image'], this.articleImageSize),
        'lazy-src': this.loadMedia(item['article-image'], 'thumbnail'),
        class: ['mb-5'],
        style: {
          width: '100%'
        }
      }
    },
    buttonTextColor(button) {
      let color = button['button-text-color']

      if (
        button['button-style'] === 'default' &&
        button['button-text-color'] === 'inherit'
      ) {
        if (button['button-background-color'] === 'var(--primary-color)') {
          let defaultColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--primary-text-color')

          color = `var(--text-${defaultColor}-color)`
        } else if (
          button['button-background-color'] === 'var(--secondary-color)'
        ) {
          let defaultColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--secondary-text-color')

          color = `var(--text-${defaultColor}-color)`
        }
      }

      return color
    },
    buttonProps(item) {
      let additionalClass = ['mb-3']

      if (this.section.layout['content-justify'] === 'start') {
        additionalClass.push('mr-3')
      }

      if (this.section.layout['content-justify'] === 'end') {
        additionalClass.push('ml-3')
      }

      return {
        class: additionalClass,
        depressed: true,
        outlined: item['button-style'] == 'outlined',
        text: item['button-style'] == 'text',
        color:
          item['button-style'] == 'text'
            ? 'transparent'
            : item['button-background-color'],
        style: {
          color: this.buttonTextColor(item),
          borderColor: item['button-background-color']
        }
      }
    }
  }
}
</script>
